module.exports = __webpack_public_path__ + "554b122c9475ac7cb7b524fd53f5bb66.svg";